import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

interface SelectorContainerProps {
  backgroundColor?: string;
  foregroundColor?: string;
}

export const SelectorWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const SelectorContainer = styled.div<SelectorContainerProps>`
  display: flex;
  align-items: center;
  background-color: ${({ backgroundColor }) => backgroundColor || '#1E7843'};
  color: ${({ foregroundColor }) => foregroundColor || '#FFFFFF'};
  padding: ${rem(8)} ${rem(12)};
  border-radius: ${rem(4)};
  cursor: pointer;
  position: relative;
  min-width: ${rem(200)};
  height: ${rem(40)};

  &:hover {
    opacity: 0.9;
  }
`;

export const CompanyLogo = styled.img`
  height: ${rem(24)};
  width: auto;
  margin-right: ${rem(10)};
`;

export const CompanyName = styled.div`
  flex: 1;
  font-size: ${rem(14)};
  font-weight: 400;
`;

export const DropdownIcon = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${rem(8)};
  font-size: ${rem(12)};

  svg {
    width: ${rem(16)};
    height: ${rem(16)};
  }
`;

export const SelectorDropdown = styled.select`
  appearance: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 1;

  &:disabled {
    cursor: not-allowed;
  }
`;